import { GemIcon, GlobeIcon, LayersIcon, MapIcon, MountainIcon, PickaxeIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'Fondamenti di Geologia e Sistemi della Terra',
    summary: "Che cos'è la geologia, il metodo del geologo, età e formazione della Terra, struttura interna a strati, crosta, mantello e nucleo, le quattro sfere del sistema Terra e il ciclo delle rocce.",
    icon: GlobeIcon,
  },
  {
    number: '2',
    title: 'Minerali, Cristalli e Ciclo delle Rocce',
    summary: "Che cos'è un minerale, cristalli e struttura atomica, silicati e minerali comuni, proprietà per riconoscerli (colore, striscio, lucentezza, durezza, sfaldatura), rocce magmatiche, sedimentarie e metamorfiche.",
    icon: GemIcon,
  },
  {
    number: '3',
    title: 'Tettonica delle Placche, Terremoti e Vulcani',
    summary: "Deriva dei continenti ed espansione dei fondali, le placche e i loro margini, nascita delle montagne, l'Italia tra due placche, onde sismiche, epicentro, magnitudo, tsunami, vulcani e rischio.",
    icon: MountainIcon,
  },
  {
    number: '4',
    title: 'Sedimentologia, Stratigrafia, Tempo Geologico e Paleontologia',
    summary: 'Il viaggio dei sedimenti, ambienti sedimentari, principi della stratigrafia, datazione relativa e assoluta, tempo di dimezzamento, scala dei tempi geologici, fossili e storia della vita.',
    icon: LayersIcon,
  },
  {
    number: '5',
    title: 'Geologia Strutturale, Cartografia Geologica e Geomorfologia',
    summary: 'Deformazione delle rocce, giacitura degli strati e bussola, pieghe e faglie, storia di Alpi e Appennini, leggere una carta geologica e una sezione, alterazione, suolo, frane e modellamento del paesaggio.',
    icon: MapIcon,
  },
  {
    number: '6',
    title: 'Geologia Applicata, Ambientale ed Economica',
    summary: 'Acque sotterranee e acquiferi, giacimenti minerari, cave e materiali da costruzione, energia dal sottosuolo e geotermia, geologia per le costruzioni, gallerie e dighe, inquinamento del sottosuolo e rischi naturali.',
    icon: PickaxeIcon,
  },
];
